export default __webpack_public_path__ + "static/media/KZ.T.11.0264.59798d78.svg";